import { HIDDEN } from '../../classnames/design-system';
import { SELECTORS } from './constants';

export class ClipboardCopy {
  handleCopy = (container) => {
    navigator.clipboard.writeText(container.dataset.value);

    this.toggleVisibility(container);

    setTimeout(() => {
      this.toggleVisibility(container);
    }, 1000);
  };

  toggleVisibility = (container) => {
    container.querySelector(`.${SELECTORS.COPY_ELEM}`).classList.toggle(HIDDEN);
    container.querySelector(`.${SELECTORS.COPIED_ELEM}`).classList.toggle(HIDDEN);
  };

  initialize = () => {
    const containers = document.querySelectorAll(`.${SELECTORS.CONTAINER}`);

    containers.forEach((container) => {
      container.addEventListener('click', () => this.handleCopy(container));
    });
  };
}
